<template>
  <div class="advisory-flow" v-if="initialized">
    <div class="content">
      <advisory-package-intro v-if="index === 0" @next="next" @close="close" />
      <advisory-package-intro-3 v-if="index === 1" @next="next" @back="back" @close="close" />
      <advisory-package-steps v-if="index === 2" @next="next" @back="back" @close="close" :backwards="advisoryStepsBackwards"/>
      <advisory-future-questions v-if="index === 3" @next="next" @back="back" @close="close" :stepper-filler="8" />
      <advisory-review-2 v-if="index === 4" @next="next" @back="back" @close="close" :stepper-filler="9"/>
      <advisory-savings-questions v-if="index === 5" @next="next" @back="back" @close="close" :stepper-filler="10" />
      <advisory-review-1 v-if="index === 6" @next="next" @back="back" @close="close" :stepper-filler="11" />
      <one-off-landing-page v-if="index === 7" @next="next" @back="back" @close="close" />
      <payment-page v-if="index === 8" @back="back" @next="next" @close="close" :insight="insight "/>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import Segment from '@/Segment';
import _ from 'lodash';
import router from '@/router';
import PaymentPage from '../../payment/PaymentPage';
import OneOffLandingPage from '../../offerings/one-off/OneOffLandingPage.vue';
import AdvisoryPackageSteps from './AdvisoryPackageSteps';
import AdvisoryPackageIntro from './AdvisoryPackageIntro.vue';
import AdvisoryPackageIntro3 from './AdvisoryPackageIntro3.vue';
import AdvisorySavingsQuestions from '../AdvisorySavingsQuestions.vue';
import AdvisoryFutureQuestions from '../AdvisoryFutureQuestions.vue';
import AdvisoryReview1 from '../AdvisoryReview1.vue';
import AdvisoryReview2 from '../AdvisoryReview2.vue';

export default {
  name: 'AdvisoryFlow',
  components: {
    OneOffLandingPage,
    AdvisoryPackageIntro3,
    AdvisorySavingsQuestions,
    AdvisoryFutureQuestions,
    AdvisoryPackageSteps,
    AdvisoryPackageIntro,
    PaymentPage,
    AdvisoryReview1,
    AdvisoryReview2,
  },
  props: {
    insight: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      index: 0,
      advisoryStepsBackwards: false,
    };
  },
  async created() {
    const utmParams = _.pickBy(router.currentRoute.query, (value, key) => (key.startsWith('utm_') && value));
    Segment.trackUserGot('AdvisoryPackageFlow', { ...utmParams });
    await this.init();
    await this.selectOffering({ offeringId: this.offeringsTypes.ADVISORY_PACKAGE });
  },
  computed: {
    ...mapGetters('oneOffOfferings', ['offeringsTypes']),
    ...mapState('oneOffOfferings', ['initialized']),
  },
  methods: {
    ...mapActions('oneOffOfferings', ['init']),
    ...mapMutations('oneOffOfferings', ['selectOffering']),
    next() {
      this.index++;
      if (this.index === 3) {
        this.advisoryStepsBackwards = true;
      }
    },
    back() {
      this.index--;
      if (this.index === 1) {
        this.advisoryStepsBackwards = false;
      }
    },
    close() {
      router.push({ path: '/sr' });
    },
  },
};
</script>

<style scoped lang="scss">
.advisory-flow {
  height: 100%;
  overflow-y: auto;

  .content {
    height: 100%;
  }
}
</style>
